import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
  isLoading,
  clearEnterpriseUsers,
  getEnterpriseList,
  getEnterpriseInfo,
  getEnterpriseRoles,
  getEnterpriseUsers,
  getImpersonatedUsers,
  getPermissions,
  getUserInfo,
  updateUser,
  stageUserForDelete,
  unstageUsersForDelete,
  deleteUser,
  inviteUser,
  showMessageBox,
  updateEnterpriseDomains,
  deleteEnterpriseDomain,
  addEnterprise,
  updateEnterpriseInfo,
  getDefaultPasswordConfiguration,
  clearEnterpriseInfo,
  setQuestion,
} from '../../actions';

import EnterpriseMaintenance from '../../components/Admin/EnterpriseMaintenance';

class EnterpriseMaintenanceContainer extends Component {
  componentWillMount() {
    this.props.getEnterpriseList();
    this.props.getPermissions();
    if (this.props.context === 'users') {
      this.props.getEnterpriseUsers(this.props.enterpriseGUID);
      this.props.getImpersonatedUsers();
    }
    if (this.props.context === 'users' && (this.props.method === 'edit' || this.props.method === 'remote-assist') && this.props.primaryGUID) {
      this.props.getUserInfo(this.props.primaryGUID);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.context === 'users' && (this.props.enterpriseGUID !== nextProps.enterpriseGUID || this.props.context !== 'users')) {
      this.props.getEnterpriseUsers(nextProps.enterpriseGUID);
      this.props.getImpersonatedUsers();
    }
    if (nextProps.enterpriseMaintenance.users && Object.keys(nextProps.enterpriseMaintenance.users).length && nextProps.context !== 'users') {
      this.props.clearEnterpriseUsers();
    }
    if (nextProps.context === 'users' && (nextProps.method === 'edit' || nextProps.method === 'remote-assist') && this.props.primaryGUID !== nextProps.primaryGUID) {
      this.props.getUserInfo(nextProps.primaryGUID);
    }
  }

  render() {
    return (
      <EnterpriseMaintenance
        addEnterprise={this.props.addEnterprise}
        clearEnterpriseInfo={this.props.clearEnterpriseInfo}
        context={this.props.context}
        deleteEnterpriseDomain={this.props.deleteEnterpriseDomain}
        deleteUser={this.props.deleteUser}
        enterpriseDetail={this.props.enterpriseMaintenance.detail}
        enterpriseGUID={this.props.enterpriseGUID}
        enterpriseUsers={this.props.enterpriseMaintenance.users}
        enterprises={this.props.enterpriseMaintenance.list}
        getDefaultPasswordConfiguration={this.props.getDefaultPasswordConfiguration}
        getEnterpriseInfo={this.props.getEnterpriseInfo}
        getEnterpriseRoles={this.props.getEnterpriseRoles}
        getEnterpriseUsers={this.props.getEnterpriseUsers}
        getUserInfo={this.props.getUserInfo}
        impersonatedUsers={this.props.enterpriseMaintenance.impersonatedUsers}
        inviteUser={this.props.inviteUser}
        isLoading={this.props.isLoading}
        licenseID={this.props.licenseID}
        location={this.props.location}
        method={this.props.method}
        permissions={this.props.permissions}
        primaryGUID={this.props.primaryGUID}
        secondaryGUID={this.props.secondaryGUID}
        setupGlobalImpersonation={this.props.setupGlobalImpersonation}
        showMessageBox={this.props.showMessageBox}
        stageUserForDelete={this.props.stageUserForDelete}
        submethod={this.props.submethod}
        thereWasAnError={this.props.thereWasAnError}
        unstageUsersForDelete={this.props.unstageUsersForDelete}
        updateEnterpriseDomains={this.props.updateEnterpriseDomains}
        updateEnterpriseInfo={this.props.updateEnterpriseInfo}
        updateUser={this.props.updateUser}
        userInfo={this.props.enterpriseMaintenance.userDetail}
        utilities={this.props.utilities}
        setQuestion={this.props.setQuestion}
        history={this.props.history}
      />
    );
  }
}

export default withRouter(connect(s => s, {
  isLoading,
  clearEnterpriseUsers,
  getEnterpriseList,
  getEnterpriseInfo,
  getEnterpriseUsers,
  getEnterpriseRoles,
  getImpersonatedUsers,
  getPermissions,
  getUserInfo,
  updateUser,
  stageUserForDelete,
  unstageUsersForDelete,
  deleteUser,
  inviteUser,
  showMessageBox,
  updateEnterpriseDomains,
  deleteEnterpriseDomain,
  addEnterprise,
  updateEnterpriseInfo,
  getDefaultPasswordConfiguration,
  clearEnterpriseInfo,
  setQuestion,
})(EnterpriseMaintenanceContainer));



// WEBPACK FOOTER //
// ./src/containers/Admin/EnterpriseMaintenance.js